"use strict";

exports.__esModule = true;
exports.default = maxTranslate;

function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}


//////////////////
// WEBPACK FOOTER
// ./~/swiper/cjs/components/core/translate/maxTranslate.js
// module id = 62
// module chunks = 0